import { render, staticRenderFns } from "./ImageHighlight.vue?vue&type=template&id=24520e0c&scoped=true&"
import script from "./ImageHighlight.vue?vue&type=script&lang=js&"
export * from "./ImageHighlight.vue?vue&type=script&lang=js&"
import style0 from "./ImageHighlight.vue?vue&type=style&index=0&id=24520e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24520e0c",
  null
  
)

export default component.exports